import { useGame } from "../../../../../contexts/game/GameContext";
import { GameKind } from "../../../../../gql/graphql";
import { LeaderboardOnlyPreview } from "./LeaderboardOnlyPreview";
import { SharedPreview } from "./SharedPreview";
import { TriviaPreview } from "./TriviaPreview";

export enum STEPS_TO_CONFIGURE_PROJECT {
  GAME_SETTINGS = "game-settings",
}

export interface GamePreviewProps {
  isFlickable?: boolean;
  step?: STEPS_TO_CONFIGURE_PROJECT;
}

export const GamePreview = ({ isFlickable, step }: GamePreviewProps) => {
  const { currentGame } = useGame();

  if (!currentGame) {
    return null;
  }

  const gamePreview = {
    [GameKind.Swiper]: <SharedPreview game={currentGame} isFlickable={isFlickable} step={step} />,
    [GameKind.QuickRank]: <SharedPreview game={currentGame} isFlickable={isFlickable} />,
    [GameKind.Rankifier]: <SharedPreview game={currentGame} isFlickable={isFlickable} />,
    [GameKind.Wordopolis]: <SharedPreview game={currentGame} isFlickable={false} step={step} />,
    [GameKind.Trivia]: <TriviaPreview game={currentGame} step={step} />,
    [GameKind.Wordle]: <LeaderboardOnlyPreview game={currentGame} step={step} />,
  }[currentGame.kind];

  return gamePreview;
};
